module.exports = "<div>\n    <ng-container #mainContainer></ng-container>\n</div>"